import { RequestType } from 'src/shared/models/request-type';

export class FormulaBuilder {
  constructor(
    public datasource: string,
    public metric: string,
    public start: string,
    public end: string,
    public untilNow: boolean,
    public aggregation: string,
    public interval: string,
    public interpolation: string,
    public integralTimeUnit: string,
    public displayInRow: boolean,
    public displayTimestamp: boolean,
    public displayCount: boolean,
    public displayMetric: boolean,
    public displayLocalDate: boolean
  ) { }

  static fromSettings(tIndabaParam: Record<string, any>): FormulaBuilder {
    const datasource = `"${tIndabaParam.base || ''}"`;
    const metric = tIndabaParam.tag_name_cell ? tIndabaParam.tag_name : `"${tIndabaParam.tag_name || ''}"`;
    const start = `"${tIndabaParam.start_date || ''}"`;
    const end = `"${tIndabaParam.end_date || ''}"`;
    const untilNow = tIndabaParam.until_now ?? false;
    const aggregation = `"${tIndabaParam.aggregation || 'none'}"`;
    const interval = `"${tIndabaParam.interval || ''}"`;
    const interpolation = `"${tIndabaParam.interpolation || ''}"`;
    const integralTimeUnit = `"${tIndabaParam.integralTimeUnit || ''}"`;
    const displayInRow = tIndabaParam.displayInRow || false;
    const displayTimestamp = tIndabaParam.displayTimestamp || false;
    const displayCount = tIndabaParam.displayCount || false;
    const displayMetric = tIndabaParam.displayMetric || false;
    const displayLocalDate = tIndabaParam.displayLocalDate ?? true;
    return new FormulaBuilder(
      datasource,
      metric,
      start,
      end,
      untilNow,
      aggregation,
      interval,
      interpolation,
      integralTimeUnit,
      displayInRow,
      displayTimestamp,
      displayCount,
      displayMetric,
      displayLocalDate
    );
  }

  buildFormula(requestType: RequestType): string {
    let modeOptional = false;
    if (
      this.interval === '""' &&
      !this.displayInRow &&
      this.displayTimestamp &&
      this.displayLocalDate &&
      this.displayMetric &&
      !this.displayCount &&
      !this.untilNow
    )
      modeOptional = true;

    let formula = '';
    switch (requestType) {
      case 'RANGE':
        if (modeOptional)
          formula = `=iobase.IDB_RANGE(${this.datasource}, ${this.metric}, ${this.start}, ${this.end}, ${this.aggregation})`;
        else
          formula = `=iobase.IDB_RANGE(${this.datasource}, ${this.metric}, ${this.start}, ${this.end}, ${this.aggregation}, ${this.interval}, ${this.displayInRow}, ${this.displayTimestamp}, ${this.displayCount}, ${this.displayMetric}, , , ${this.displayLocalDate}, ${this.untilNow})`;
        break;
      case 'VALUES':
        formula = `=iobase.IDB_VALUES(${this.datasource}, ${this.metric}, ${this.start}, ${this.end}, , ,` +
          `${this.displayLocalDate}, ${this.untilNow}, ${this.displayInRow}, ${this.displayTimestamp}, ${this.displayCount}, ${this.displayMetric})`;
        break;
      case 'AGGREGATED_VALUE':
        formula = `=iobase.IDB_AGGREGATED_VALUE(${this.datasource}, ${this.metric}, ${this.start}, ${this.end},` + 
          `${this.aggregation}, ${this.interval}, ${this.interpolation}, ${this.integralTimeUnit}, , ,` +
          `${this.displayLocalDate}, ${this.untilNow}, ${this.displayInRow}, ${this.displayTimestamp}, ${this.displayMetric})`;
        break;
      case 'AGGREGATED_VALUES':
        formula = `=iobase.IDB_AGGREGATED_VALUES(${this.datasource}, ${this.metric}, ${this.start}, ` + 
          `${this.end}, ${this.aggregation}, ${this.interval}, ${this.interpolation}, ${this.integralTimeUnit}, , ,` + 
          `${this.displayLocalDate}, ${this.untilNow}, ${this.displayInRow}, ${this.displayTimestamp}, ${this.displayCount}, ${this.displayMetric})`;
        break;
      case 'INSTANT':
        if (modeOptional)
          formula = `=iobase.IDB_INSTANT(${this.datasource}, ${this.metric}, ${this.start})`;
        else
          formula = `=iobase.IDB_INSTANT(${this.datasource}, ${this.metric}, ${this.start}, ${this.displayInRow}, ${this.displayTimestamp}, ${this.displayMetric}, ${this.displayLocalDate})`;
        break;
      case 'INSTANT_AFTER':
        if (modeOptional)
          formula = `=iobase.IDB_INSTANT_AFTER(${this.datasource}, ${this.metric}, ${this.start}, "1d")`;
        else
          formula = `=iobase.IDB_INSTANT_AFTER(${this.datasource}, ${this.metric}, ${this.start}, "1d", ${this.displayInRow}, ${this.displayTimestamp}, ${this.displayMetric}, ${this.displayLocalDate})`;
        break;
      case 'INSTANT_BEFORE':
        if (modeOptional)
          formula = `=iobase.IDB_INSTANT_BEFORE(${this.datasource}, ${this.metric}, ${this.start}, "1d")`;
        else
          formula = `=iobase.IDB_INSTANT_BEFORE(${this.datasource}, ${this.metric}, ${this.start}, "1d", ${this.displayInRow}, ${this.displayTimestamp}, ${this.displayMetric}, ${this.displayLocalDate})`;
        break;
      case 'LATEST':
        if (modeOptional) formula = `=iobase.IDB_LATEST(${this.datasource}, ${this.metric})`;
        else
          formula = `=iobase.IDB_LATEST(${this.datasource}, ${this.metric}, ${this.displayInRow}, ${this.displayTimestamp}, ${this.displayMetric}, ${this.displayLocalDate})`;
        break;
    }

    return formula;
  }
}
